import { v1 as uuidv1 } from 'uuid'
import { DeltakerTypes, IDeltaker } from '../types'
import { mergeKeyWith } from '../../../common/query'
import { Immutable } from 'immer'
import { IKvitteringData } from '../../../ducks/kvittering/types'

export const initialDeltaker = (): IDeltaker => ({
  id: uuidv1(),
  navn: '',
  _links: {
    self: {
      href: '',
    },
  },
})

export const getKvitteringId = (url: string): string => {
  const id = url.match(
    /tilsynskvitteringer\/(\d+)\/(virksomhet|mattilsynet|andre)-deltagere/
  )?.[1]

  if (!id) {
    throw new Error('URL must include kvitteringId')
  }

  return id
}

export const getDeltakerKeys = (entity: string) => {
  const keys = {
    all: [{ entity }] as const,

    /** Used as defaultMutation key or filter key */
    addBase: () => mergeKeyWith(keys.all, { action: 'add' }),
    /** Used as useMutation key */
    add: (kvitteringId: string) =>
      mergeKeyWith(keys.addBase(), { kvitteringId }),

    /** Used as defaultMutation key or filter key */
    updateBase: () => mergeKeyWith(keys.all, { action: 'update-beskrivelse' }),
    /** Used as useMutation key */
    update: (kvitteringId: string) =>
      mergeKeyWith(keys.updateBase(), { kvitteringId }),

    /** Used as defaultMutation key or filter key */
    removeBase: () => mergeKeyWith(keys.all, { action: 'remove' }),
    /** Used as useMutation key */
    remove: (kvitteringId: string) =>
      mergeKeyWith(keys.removeBase(), { kvitteringId }),
  } as const

  return keys
}

export const getPreviousDeltakere = (
  type: string,
  kvittering?: Immutable<IKvitteringData>
) => {
  switch (type) {
    case DeltakerTypes.VIRKSOMHET:
      return kvittering?.virksomhetsDeltagere ?? []
    case DeltakerTypes.MATTILSYNET:
      return kvittering?.mattilsynetDeltagere ?? []
    case DeltakerTypes.ANDRE:
      return kvittering?.andreDeltagere ?? []
    default:
      return []
  }
}

export const isDeltakerEqual = (
  a: Immutable<IDeltaker>,
  b: Immutable<IDeltaker>
) => {
  const isDeltakerIdsUndefined = a.id === undefined || b.id === undefined

  return !isDeltakerIdsUndefined && a.id === b.id
}

export const deltakerTypeToKvitteringField = (type: DeltakerTypes) => {
  switch (type) {
    case DeltakerTypes.VIRKSOMHET:
      return 'virksomhetsDeltagere'
    case DeltakerTypes.MATTILSYNET:
      return 'mattilsynetDeltagere'
    case DeltakerTypes.ANDRE:
      return 'andreDeltagere'
    default:
      return ''
  }
}
